import type {FC} from 'react';
import {Theme} from '@wellstone-solutions/common';
import {Box, Divider, Link, Stack, Typography} from '@wellstone-solutions/web';

import {
  WEBSITE_URL,
  TERMS_OF_USE_URL,
  PRIVACY_POLICY_URL,
  EMAIL_ADDRESS,
} from './constants';

interface SiteFooterProps {
  version: string;
}

export const SiteFooter: FC<SiteFooterProps> = ({version}) => {
  return (
    <Box sx={styles.footer} data-testid="site-footer">
      <Divider />
      <Stack sx={styles.footerContent} data-testid="site-footer-content">
        <Stack sx={styles.info}>
          <Stack sx={styles.versionRow}>
            <Typography sx={styles.versionText}>
              Pathfinder Bridge {version}
            </Typography>
            <Typography>
              © {new Date().getFullYear()}{' '}
              <Link
                rel="noopener noreferrer"
                href={WEBSITE_URL}
                target="_blank"
                sx={styles.link}>
                Pathfinder Solutions PBC
              </Link>
            </Typography>
          </Stack>
          <Stack sx={styles.linksRow}>
            <Link href={`mailto:${EMAIL_ADDRESS}`} sx={styles.link}>
              {EMAIL_ADDRESS}
            </Link>
            <Link
              rel="noopener noreferrer"
              href={TERMS_OF_USE_URL}
              target="_blank"
              sx={styles.link}>
              Terms of Use
            </Link>
            <Link
              rel="noopener noreferrer"
              href={PRIVACY_POLICY_URL}
              target="_blank"
              sx={styles.link}>
              Privacy Policy
            </Link>
          </Stack>
        </Stack>
      </Stack>
    </Box>
  );
};

const styles = {
  footer: {
    marginTop: 2,
    backgroundColor: Theme.colorPalette.mediumLight,
    color: Theme.colorPalette.darkest,
  },
  footerContent: {
    padding: '32px 28px',
    alignItems: {xs: 'center', md: 'flex-end'},
  },
  info: {
    gap: 1,
    alignItems: {xs: 'center', md: 'flex-end'},
  },
  versionRow: {
    flexDirection: {xs: 'column', sm: 'row'},
    alignItems: 'center',
    gap: 1,
  },
  versionText: {
    fontWeight: 800,
  },
  linksRow: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'center',
    gap: '12px',
  },
  link: {
    color: '#0277BD',
    textDecoration: 'underline',
  },
};
